import { Modal, Elements, TextButton } from '@tfo/common'
import * as React from 'react'
import { injectIntl, WrappedComponentProps, FormattedMessage } from 'react-intl'

import './ScriveInfoModal.scss'

const { Heading4, Heading5, Paragraph } = Elements

const ScriveInfoModal: React.FunctionComponent<Modal.ModalProps & {
    companyName: string
} & WrappedComponentProps> = props => {
    const { onCloseClick, companyName } = props

    return (
        <Modal.Modal
            className={'InfoModal'}
            onCloseClick={onCloseClick}>
            <div className={'ContentWrapper'}>
                <Heading4 className={'Heading'}>
                    <FormattedMessage id="individual.scriveInfo.heading1" />
                </Heading4>
                <Paragraph className={'Body'}>
                    <FormattedMessage
                        id="individual.scriveInfo.body"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Heading5 className={'Heading'}>
                    <FormattedMessage id="individual.scriveInfo.heading2" />
                </Heading5>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item1"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item2"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item3"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item4"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item5"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'BulletItem'}>
                    <FormattedMessage
                        id="individual.scriveInfo.list.item6"
                        values={{ companyName: companyName }} />
                </Paragraph>
                <Paragraph className={'ModalFooter'}>
                    <FormattedMessage
                        id="individual.scriveInfo.footer"
                        values={{
                            link: (
                                <a
                                    href={props.intl.formatMessage({ id: 'individual.scriveInfo.footer.link.url' })}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FormattedMessage id="individual.scriveInfo.footer.link.text" />
                                </a>
                            ),
                        }}
                    />
                </Paragraph>
                <TextButton
                    className={'ModalCloseButton'}
                    onClick={() => onCloseClick()}>
                    <FormattedMessage id="individual.scriveInfo.closeButton" />
                </TextButton>
            </div>
        </Modal.Modal>
    )
}

export default injectIntl(ScriveInfoModal)